
import { motion } from 'framer-motion';
import { useState } from 'react';

const Partners = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const partners = [
    { name: 'Maersk', category: 'Shipping Line' },
    { name: 'MSC', category: 'Shipping Line' },
    { name: 'CMA CGM', category: 'Shipping Line' },
    { name: 'Emirates SkyCargo', category: 'Air Cargo' },
    { name: 'Lufthansa Cargo', category: 'Air Cargo' },
    { name: 'DHL', category: 'Express Delivery' },
    { name: 'FedEx', category: 'Express Delivery' },
    { name: 'UPS', category: 'Logistics' },
    { name: 'IBM', category: 'Technology' },
    { name: 'Oracle', category: 'Technology' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold mb-4">
            Our Strategic Partners
          </h2>
          <p className="text-lg text-gray-600">
            Collaborating with industry leaders to deliver excellence
          </p>
        </motion.div>

        <div className="relative">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {partners.map((partner, index) => (
              <motion.div
                key={partner.name}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                onMouseEnter={() => setActiveIndex(index)}
                className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all cursor-pointer group hover:bg-white border border-transparent hover:border-gray-200"
              >
                <div className="text-center">
                  <div
                    className={`text-2xl font-bold mb-2 transition-colors ${
                      activeIndex === index
                        ? 'text-primary-blue'
                        : 'text-gray-400 group-hover:text-primary-blue'
                    }`}
                  >
                    {partner.name}
                  </div>
                  <div className="text-sm text-gray-500">{partner.category}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
